<template>
  <section>
    <div
      v-for="timeSheet in timeSheetsList"
      :key="timeSheet.currentVersion.id"
      class="time-sheet-details-body"
    >
      <TimeSheetDetailsPdf
        :time-sheet="timeSheet.currentVersion"
        :time-sheet-attachments="timeSheet.attachments"
        :history="timeSheet.historyVersions"
        :batch="true"
      />
    </div>
  </section>
</template>

<script>
import TimeSheetDetailsPdf from './TimeSheetDetailsPdf';
import { TimeSheetsListingGetters } from '@/app/features/time-sheets/features/time-sheets-listing/time-sheets-listing.keys';

export default {
  name: 'TimeSheetBatchPdf',
  components: {
    TimeSheetDetailsPdf
  },
  computed: {
    timeSheetsList() {
      return this.$store.getters[TimeSheetsListingGetters.GetBatchTimeSheetsList];
    }
  },
  updated() {
    this.$emit('readyToExport');
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.time-sheet-details-body {
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    page-break-after: always;
  }
}
</style>
